// extracted by mini-css-extract-plugin
export default {"d3Chart":"d3Chart-aMfa9","axis":"axis-O2D_U","axisLabel":"axisLabel-rPDj3"};